// Soil-based farm data - Germany, France, and Spain only
export const farmsData = [
  {
    id: 1,
    name: "Green Valley Farm",
    owner: "Jean Dupont",
    region: "France",
    soilScore: 78,
    acres: 450,
    investment: "€45,000",
    practices: ["Cover Crops", "Minimal Tillage", "Composting"],
    image: "🌱",
    description:
      "Sustainable farming in the heart of France with focus on soil regeneration",
    yearEstablished: 2015,
    certifications: ["Organic", "Fair Trade"],
    farmType: "Soil-Based",
  },
  {
    id: 2,
    name: "Sustainable Acres",
    owner: "Klaus Müller",
    region: "Germany",
    soilScore: 72,
    acres: 280,
    investment: "€38,000",
    practices: ["Reduced Tillage", "Mulching", "Crop Rotation"],
    image: "",
    description:
      "German precision in regenerative agriculture with zero-waste approach",
    yearEstablished: 2018,
    certifications: ["Organic", "EU Ecolabel"],
    farmType: "Soil-Based",
  },
  {
    id: 3,
    name: "Prairie Regeneration",
    owner: "Carlos Rodriguez",
    region: "Spain",
    soilScore: 82,
    acres: 400,
    investment: "€48,000",
    practices: ["Native Plantings", "Soil Conservation", "Composting"],
    image: "🌾",
    description:
      "Spanish prairie restoration with emphasis on soil health and biodiversity",
    yearEstablished: 2016,
    certifications: ["Organic", "Soil Trust"],
    farmType: "Soil-Based",
  },
  {
    id: 4,
    name: "Biochar Innovations",
    owner: "Marie Laurent",
    region: "France",
    soilScore: 85,
    acres: 320,
    investment: "€52,000",
    practices: ["Biochar Amendment", "Cover Crops", "Deep Mulching"],
    image: "🌱",
    description:
      "Cutting-edge biochar-based soil improvement techniques in French countryside",
    yearEstablished: 2017,
    certifications: ["Organic", "Carbon Neutral"],
    farmType: "Soil-Based",
  },
  {
    id: 5,
    name: "Black Forest Soil Lab",
    owner: "Hans Weber",
    region: "Germany",
    soilScore: 88,
    acres: 350,
    investment: "€55,000",
    practices: ["Soil Testing", "Microorganism Cultivation", "Vermicomposting"],
    image: "🌾",
    description:
      "Advanced soil biology research and regeneration in the Black Forest region",
    yearEstablished: 2014,
    certifications: ["Organic", "Research Certified"],
    farmType: "Soil-Based",
  },
  {
    id: 6,
    name: "Tierra Regenerativa",
    owner: "Isabel Moreno",
    region: "Spain",
    soilScore: 80,
    acres: 280,
    investment: "€41,000",
    practices: ["Soil Recovery", "Crop Rotation", "No-Till Farming"],
    image: "🌾",
    description:
      "Dedicated to restoring degraded Spanish soils through regenerative practices",
    yearEstablished: 2015,
    certifications: ["Organic", "Soil Restoration"],
    farmType: "Soil-Based",
  },
  {
    id: 7,
    name: "Loire Valley Compost Co.",
    owner: "Thomas Mercier",
    region: "France",
    soilScore: 81,
    acres: 220,
    investment: "€39,500",
    practices: ["Compost Production", "Soil Amendment", "Organic Farming"],
    image: "🌱",
    description:
      "Specialized compost production enhancing soil fertility throughout Loire Valley",
    yearEstablished: 2013,
    certifications: ["Organic", "Compost Certified"],
    farmType: "Soil-Based",
  },
  {
    id: 8,
    name: "Saxon Soil Heritage",
    owner: "Friedrich Hoffmann",
    region: "Germany",
    soilScore: 79,
    acres: 410,
    investment: "€46,500",
    practices: ["Soil Mapping", "Microbial Enhancement", "Crop Rotation"],
    image: "🌾",
    description:
      "Data-driven soil management combining traditional and modern regeneration techniques",
    yearEstablished: 2016,
    certifications: ["Organic", "ISO Certified"],
    farmType: "Soil-Based",
  },
  {
    id: 9,
    name: "Andalusian Soil Revival",
    owner: "Miguel Santos",
    region: "Spain",
    soilScore: 76,
    acres: 520,
    investment: "€58,000",
    practices: ["Desert Soil Recovery", "Aquaponics", "Mulching"],
    image: "🌾",
    description:
      "Innovative techniques to restore arid Spanish soils for sustainable agriculture",
    yearEstablished: 2017,
    certifications: ["Organic", "Water Conservation"],
    farmType: "Soil-Based",
  },
  {
    id: 10,
    name: "Normandy Mineral Lab",
    owner: "Véronique Dubois",
    region: "France",
    soilScore: 84,
    acres: 290,
    investment: "€50,000",
    practices: ["Mineral Supplementation", "pH Balancing", "Soil Testing"],
    image: "🌾",
    description:
      "Laboratory-grade soil optimization for premium crop production in Normandy",
    yearEstablished: 2014,
    certifications: ["Organic", "Research Partner"],
    farmType: "Soil-Based",
  },
  {
    id: 11,
    name: "Rhine Valley Regeneration",
    owner: "Anna Schmidt",
    region: "Germany",
    soilScore: 86,
    acres: 380,
    investment: "€51,000",
    practices: ["Soil Biota Restoration", "Cover Crops", "Composting"],
    image: "🌱",
    description:
      "Comprehensive soil ecosystem restoration along the Rhine Valley",
    yearEstablished: 2015,
    certifications: ["Organic", "Biota Certified"],
    farmType: "Soil-Based",
  },
  {
    id: 12,
    name: "Castilian Earth Foundation",
    owner: "Rosa García",
    region: "Spain",
    soilScore: 83,
    acres: 450,
    investment: "€54,000",
    practices: [
      "Soil Foundation Building",
      "Long-term Restoration",
      "Training",
    ],
    image: "🌾",
    description:
      "Building soil health foundations for sustainable agriculture across Castile",
    yearEstablished: 2012,
    certifications: ["Organic", "Educational Hub"],
    farmType: "Soil-Based",
  },
];

export default farmsData;
